// Section 17 and 18: Food priority order policy. A ranked group list with saved presets
// (structured value, no option list). The preview names the first and last groups with members.
// Default: config.policies.defaults.foodPriority.
import type { Config } from '../../config';
import { noChangeCost, noProblem } from '../../core/content-helpers';
import { definePolicy, noModifiers } from '../../core/registry';

export function foodPriority(config: Config) {
  return definePolicy({
    id: 'foodPriority',
    label: 'Food priority order',
    section: 'S18',
    group: 'rations',
    options: null,
    default: config.policies.defaults.foodPriority,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    affects(ctx, order) {
      const rows = order
        .map((id) => ({
          group: ctx.registry.priorityGroups[id].label,
          count: ctx.registry.priorityGroups[id].members(ctx).length,
        }))
        .filter((r) => r.count > 0);
      const first = rows[0];
      const last = rows[rows.length - 1];
      if (first === undefined || last === undefined) return [];
      return [
        {
          key: 'policy.foodPriority.order',
          params: {
            first: first.group,
            firstCount: first.count,
            last: last.group,
            lastCount: last.count,
          },
        },
      ];
    },
    validate: noProblem,
  });
}
